document.addEventListener('DOMContentLoaded', function () {
    const quantityInput = document.querySelector('.quantity-input__element');
    if (quantityInput) {
        quantityInput.addEventListener('change', function () {
            let newQty = Number(quantityInput.value);
    
            const discountMessage = document.querySelector('.js-discount-message');
            if (discountMessage) {
            if (newQty < 2) {
                discountMessage.style.display = "none";
            } else {
                let limitQuantity = Number(discountMessage.dataset.discountQuantity);
                if (newQty >= limitQuantity) {
                discountMessage.innerHTML = discountMessage.dataset.finalMessage; 
                } else {
                let message = discountMessage.dataset.discountMessage;
                message = message.replace('#quantity#', (limitQuantity - newQty));
                discountMessage.innerHTML = message;
                }
    
                discountMessage.style.display = "block";
            }
            }
        });
    }
});
